import {ALERT} from "../environment";
import {isFunction, isString} from "underscore";

const AI_DISABLED = "AI_DISABLED";
const AI_UNAUTHORIZED = "AI_UNAUTHORIZED";

const AI_DISABLED_MESSAGE = "AI functions are disabled for your organization";
const AI_UNAUTHORIZED_MESSAGE = "You are not authorized to access AI functions";

export const handleError = (error, handler) => {
  console.error(error);
  ALERT.error(error.message);
  if (isFunction(handler)) {
    handler(false);
  }
};

export const handleSubscriptionError = (error, whichSubscription) => {
  if (isString(error?.message)) {
    const match = error.message.match(/\d+/);
    if (match) {
      console.error(
        `Error: ${whichSubscription} websocket closed with event ${parseInt(match[0], 10)}`,
      );
      return;
    }
  }

  console.error(error);
};

export const createAIDisabledError = () => {
  const error = new Error(AI_DISABLED_MESSAGE);
  error.code = AI_DISABLED;
  return error;
};

export const createAIUnauthorizedError = () => {
  const error = new Error(AI_UNAUTHORIZED_MESSAGE);
  error.code = AI_UNAUTHORIZED;
  return error;
};

export const isAIDisabledError = (error) =>
  error?.code === AI_DISABLED || error?.message?.includes("AI functions are disabled");

export const isAIUnauthorizedError = (error) =>
  error?.code === AI_UNAUTHORIZED ||
  error?.message?.includes("You are not authorized to access AI functions");
